import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/findForNotifyAll`;

export const ROUTE: RouteDefinition = `${baseRoute}/findForNotifyAll`;

export const URL = (): RouteDefinition => `${baseRoute}/findForNotifyAll`;
